/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE_SERVICEDESK_CONTEXT = 'SERVICEDESK_CONTEXT';
